import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row g-6 g-xl-9" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "card mb-5 mb-xl-10" }
const _hoisted_4 = { class: "card-header mt-4" }
const _hoisted_5 = { class: "card-title flex-column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Schedule", -1)
const _hoisted_7 = { class: "fs-6 fw-bold text-muted" }
const _hoisted_8 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_9 = { class: "card-body p-0" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "card mb-5 mb-xl-10" }
const _hoisted_12 = { class: "card-header mt-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "card-title flex-column" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "Recent Communications"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-muted" }, "showing last seven days")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_15 = { class: "card-body p-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-bullhorn fa-4x" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "d-flex flex-column mb-6 mt-4 px-4 mx-6"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "d-flex flex-column" }
const _hoisted_20 = {
  class: "fs-3 fw-bolder text-white text-truncate",
  style: {"text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_21 = {
  key: 0,
  class: "fs-7"
}
const _hoisted_22 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_23 = { class: "fs-5 text-gray-800 fst-italic" }
const _hoisted_24 = { class: "fs-6 text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductionCard = _resolveComponent("ProductionCard")!
  const _component_ScheduleWidget = _resolveComponent("ScheduleWidget")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_CommunicationViewerModal = _resolveComponent("CommunicationViewerModal")!
  const _component_CommunicationModal = _resolveComponent("CommunicationModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isOrganization)
      ? (_openBlock(), _createBlock(_component_ProductionCard, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.calls.length) + " calls this week", 1)
            ]),
            (_ctx.userStore.canManage(_ctx.userStore.currentEntity))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-sm",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.invokeAddCall && _ctx.invokeAddCall(...args)))
                  }, "Add Call")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createVNode(_component_ScheduleWidget, {
              schedule: _ctx.calls,
              "element-loading-text": "Loading Schedule"
            }, null, 8, ["schedule"]), [
              [_directive_loading, _ctx.scheduleLoading]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            (_ctx.userStore.canManage(_ctx.userStore.currentEntity))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.invokeAddCommunication && _ctx.invokeAddCommunication(...args))),
                    href: "#",
                    class: "btn btn-sm btn-primary my-1 d-none d-md-block"
                  }, "Send Communication"),
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.invokeAddCommunication && _ctx.invokeAddCommunication(...args))),
                    href: "#",
                    class: "btn btn-sm btn-primary my-1 d-md-none"
                  }, "Send")
                ]))
              : _createCommentVNode("", true)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_ctx.publishedCommunications.length === 0)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 0,
                  description: "No communications in the last 7 days"
                }, {
                  image: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publishedCommunications, (communication) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "d-flex flex-column cursor-pointer mb-4",
                      key: communication.communicationId,
                      onClick: ($event: any) => (_ctx.viewCommunication(communication)),
                      style: {"width":"100%"}
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(communication.title), 1),
                        (communication.authorFirstName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, " posted by " + _toDisplayString(communication.authorFirstName) + " " + _toDisplayString(communication.authorLastName), 1))
                          : _createCommentVNode("", true)
                      ]),
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(communication.entityName), 1),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.getRelativeDateTime(communication.lastUpdated)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_18))
                  }), 128))
                ]))
          ])), [
            [_directive_loading, _ctx.communicationsLoading]
          ])
        ])
      ])
    ]),
    _createVNode(_component_CommunicationViewerModal, { ref: "communicationViewerModal" }, null, 512),
    _createVNode(_component_CommunicationModal, { ref: "communicationModal" }, null, 512)
  ]))
}